<template>
  <div class="v_main g-flex-align-center g-flex-justify-center">
    <el-card v-loading="loading">
      <div class="v-main-head-container">
        <div class="v-main-head g-flex-align-center">
          <div class="v-main-head-img">
            <img :src="$global.adminUser.avatar" alt=""/>
          </div>
          <div class="v-main-head-left">
            <p class="v-head-name">姓名:
              <span v-show="!editNameShow">{{$global.adminUser.name}}</span>
              <i v-show="!editNameShow" class="iconfont icon-bianji" @click="editNameClick"></i>
              <el-input :autofocus="true" resize="none" v-show="editNameShow" @blur="editNameBlur" type="textarea" autosize placeholder="请输入内容" v-model="name"/>
            </p>
            <p>
              登录时间:
              <span>{{formatDate($global.adminUser.login_time, 'yyyy-MM-dd hh:mm:ss')}}</span>
            </p>
            <p>角色:
              <span>{{$global.adminUser.type == 2 ? '客服': '超级管理员'}}</span>
            </p>
            <p>备注:
              <span v-show="!editShow">{{$global.adminUser.remark}}</span>
              <i v-show="!editShow" class="iconfont icon-bianji" @click="editRemarkClick"></i>
              <el-input resize="none" :autofocus="true" v-show="editShow" @blur="editRemarkBlur" type="textarea" autosize placeholder="请输入内容" v-model="remark"/>
            </p>
          </div>

          <div class="v-main-head-right">
              <el-upload class="upload-button" action="" :http-request="uploadFile" :show-file-list="false" :accept="uploadAccept">
                <el-button type="primary" size="medium">更换头像<i class="el-icon-arrow-right el-icon--right"></i></el-button>
              </el-upload>
          </div>
        </div>

      </div>
      <div class="v-main-middle">
        <ul class="g-flex-align-center">
          <li v-show="$global.adminUser['kefu_id']" class="g-flex-column g-flex-align-center" >
            <img src="@/assets/img/main_kefuid.png" alt=""/>
            <p>客服ID</p>
            <span>{{ $global.adminUser['kefu_id'] }}</span>
          </li>
          <li v-show="$global.adminUser['ent_id']" class="g-flex-column g-flex-align-center" >
            <img src="@/assets/img/main_entid.png" alt=""/>
            <p>企业ID</p>
            <span>{{ $global.adminUser['ent_id'] }}</span>
          </li>
          <li v-show="$global.adminUser['user_name']" class="g-flex-column g-flex-align-center" >
            <img src="@/assets/img/main_name.png" alt=""/>
            <p>用户名</p>
            <span>{{ $global.adminUser['user_name'] }}</span>
          </li>
          <li v-show="$global.adminUser['ip']" class="g-flex-column g-flex-align-center" >
            <img src="@/assets/img/main_ip.png" alt=""/>
            <p>IP</p>
            <span>{{ $global.adminUser['ip'] }}</span>
          </li>
          <li v-show="$global.adminUser['ip_address']" class="g-flex-column g-flex-align-center" >
            <img src="@/assets/img/main_ipaddress.png" alt=""/>
            <p>IP地址</p>
            <span>{{ $global.adminUser['ip_address'] }}</span>
          </li>
          <li v-show="($global.adminUser['login_time']) && ($global.adminUser.type == 4)" class="g-flex-column g-flex-align-center" >
            <img src="@/assets/img/main_logintime.png" alt=""/>
            <p>登录时间</p>
            <span>{{ formatDate($global.adminUser['login_time'], 'yyyy-MM-dd hh:mm:ss') }}</span>
          </li>
          <li v-show="($global.adminUser['expire_time']) && ($global.adminUser.type !== 4)" class="g-flex-column g-flex-align-center" >
            <img src="@/assets/img/main_logintime.png" alt=""/>
            <p>到期时间</p>
            <span>{{ formatDate($global.adminUser['expire_time'], 'yyyy-MM-dd hh:mm:ss') }}</span>
          </li>
        </ul>
      </div>

       <div class="v-main-bottom g-flex-align-center g-flex-justify-center">
        <el-button type="primary" size="medium" @click="changePwdClick">修改密码<i class="el-icon-arrow-right el-icon--right"></i></el-button>
       </div>
    </el-card>

    <el-dialog title="修改密码" :visible.sync="form" :close-on-click-modal="false" top="30vh" width="500px">
      <el-form :model="formData" label-width="100px" ref="form" :rules="rules" >
        <el-form-item label="原密码" prop="old_password">
            <el-input v-model="formData.old_password" placeholder="请输入原密码" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
            <el-input v-model="formData.password" placeholder="请输入新密码" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
          <el-button @click="form = false">取 消</el-button>
          <el-button type="primary" @click="save()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script> 
  import { apiUploadKefuAvatar, apiSaveSelfInfo } from '@/utils/api.js' 
  import { formatDate } from '@/utils/index.js';

  export default {
    data() {
      return {
        loading: false,

        editNameShow: false,
        editShow: false,

        name: this.$global.adminUser.name,
        remark: this.$global.adminUser.remark, 

        form: false,

        uploadAccept: ".png, .jpg, jpeg, .JPG, .JPEG, .PNG",

        formData: {
          old_password: '',
          password: ''
        },

        rules: {
            old_password: [
                {required: true, message: '原密码不可为空', trigger: 'blur'}
            ],
            password: [
                {required: true, message: '密码不可为空', trigger: 'blur'}
            ]
        }
      }
    },
    methods: {
      formatDate,

      // 上传
      async uploadFile(param) {
       let accArr = ['image/png', 'image/jpg', 'image/jpeg', 'image/JPG', 'image/JPEG', 'image/PNG']
        if(accArr.indexOf(param.file.type) === -1) return this.$message.error('请上传正确的图片类型!')
        let formData = new FormData()
        formData.append('file', param.file)
        this.loading = true
        const { success, data } = await apiUploadKefuAvatar(formData)
        if(!success) return this.loading = false
        this.changeAvatar(data.filePath)
      },

      async changeAvatar(path) {
        const { success, data } = await apiSaveSelfInfo({ avatar: path })
        this.loading = false
        if(!success) return
        this.$message.success(data.msg)
        this.$global.adminUser.avatar = path
      },


      editNameClick() {
        this.name = this.$global.adminUser.name
        this.editNameShow = true
      },

      // 编辑名字
      async editNameBlur() {
        this.loading = true
        const { success, data } = await apiSaveSelfInfo({ name: this.name })
        this.loading = false
        if(!success) return
        this.$global.adminUser.name = this.name
        this.$message.success(data.msg)
        this.editNameShow = false
      },
      
      editRemarkClick() {
        this.remark = this.$global.adminUser.remark 
        this.editShow = true
      },

      // 编辑个签
      async editRemarkBlur() {
        this.loading = true
        const { success, data } = await apiSaveSelfInfo({ remark: this.remark })
        this.loading = false
        if(!success) return
        this.$global.adminUser.remark = this.remark
        this.$message.success(data.msg)
        this.editShow = false
      },
      
      // 修改密码展示
      changePwdClick() {
        this.formData.old_password = ''
        this.formData.password = ''
        this.form = true
      },

      // 确定修改密码
      save() {
        this.$refs['form'].validate(async (valid) => {
          if(valid) {
            const loading = this.$loading()
            const { success, data } = await apiSaveSelfInfo(this.formData)
            loading.close()
            if(!success) return
            this.$message.success(data.msg)
            this.form = false
          }else {
            return false
          }
        })
      },
    }
  }
</script>

<style lang="scss">
.v_main {
  height: 100%;
  img {
    vertical-align: middle;
    object-fit: cover;
  }
  .el-card {
    min-width: 980px;
    width: 90%;
    height: 800px;
    .el-card__body {
      padding: 0px;
      .v-main-head-container {
        background-image: url('../../assets/img/main_user_bg.png');
        background-size: cover;
        background-repeat: no-repeat;
        .v-main-head {
          padding: 70px 86px 52px;
          .v-main-head-img {
            cursor: pointer;
            border-radius: 50%;
            border: 6px solid #6EB1FA;
            img {
              border-radius: 50%;
              width: 170px;
              height: 170px;
              object-fit: cover;
            }
          }
          .v-main-head-left {
            padding-left: 34px;
            flex: 1;
            p {
              display: flex;
              align-items: center;
              font-size: $middle-font-size;
              padding-top: 16px;
              color: #838080;
              span {
                padding-left: 10px;
              }
              &:nth-last-of-type(1) {
                width: 500px;
                @include textEllipsis();
                i {
                  padding-left: 10px;
                  font-size: 24px;
                  cursor: pointer;
                  color: $mainBlue;
                }
                .el-textarea {
                  padding-left: 10px;
                }
              }
            }
            .v-head-name {
              color: #010100;
              padding-bottom: 6px;
              font-size: $big-font-size;
              span {
                padding-left: 10px;
              }
              i {
                padding-left: 10px;
                font-size: 24px;
                cursor: pointer;
                color: $mainBlue;
              }
              .el-textarea {
                flex: 1;
                padding-left: 10px;
              }
            }
          }

          .v-main-head-right {
            padding-right: 80px;
            .el-button {
              background: $mainBlue;
            }
          }
        }
      }

      .v-main-middle {
        padding: 70px 100px;
        border-bottom: 5px solid #EEEEEE;
        ul {
          li {
            flex: 1;
            font-size: $middle-font-size;
            color: $black;
            img {
              width: 110px;
              height: 110px;
              border-radius: 50%;
            }
            p {
              padding-top: 17px;
              padding-bottom: 26px;
              color: #9F9E9E;
            }
          }
        }
      }

      .v-main-bottom {
        padding: 80px;
        .el-button {
          background-color: $mainBlue;
          padding: 10px 40px;
          font-size: 18px;
        }
      }
    }
  }
}
</style>